import {checkUnevaluatedLinesProps} from "types/approvePopup";
import React from "react";
import {Info} from "lucide-react";
import {ICON_SIZE} from "components/common/constants";

export const CheckUnevaluatedLines = ({
                                          hasUnevaluatedLines,
                                          translate
                                      }: checkUnevaluatedLinesProps): React.ReactElement => {

    if (hasUnevaluatedLines) {
        return (
            <div className={"d-flex align-items-center ast_hasUnevaluatedLines"}>
                <Info size={ICON_SIZE.SMALL} className={"me-3"}/>
                {translate("popUp.approve.youHaveUnevaluatedLines")}
            </div>
        )
    }

    return <></>;
}

export const CheckDraftComment = ({numberOfTasks, showComments, translate}): React.ReactElement => {
    if (showComments && numberOfTasks === 1) return null;

    return (
        <span className={"d-flex align-items-center mt-4"}>
            <Info size={ICON_SIZE.SMALL} className={"me-3"}/>
            {numberOfTasks > 1 ?
                (
                    <span className={"ast_multipleTaskWithDraftComments"}>
                        <span>{translate("popUp.approve.multipleTasksWithDraftComments")}</span>
                        {showComments &&
                            <div className={"ast_commentOverrideWarning"}>
                                {translate("popUp.approve.commentOverrideWarning")}
                            </div>
                        }
                    </span>
                ) :
                <span className={"ast_singleTaskWithDraftComment"}>
                    {translate("popUp.approve.singleTaskWithDraftComment")}
                </span>
            }
        </span>
    );
}

